*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  --ch-tab-transition-duration: 150ms;
  display: grid;
  block-size: 100%;
  inline-size: 100%;
}

:host([type=inlineStart]) {
  grid-template-columns: max-content 1fr;
}

:host(.ch-tab-direction--block) {
  grid-template-rows: max-content 1fr;
}

:host([type=inlineEnd]) {
  grid-template-columns: 1fr max-content;
}

:where(button) {
  all: unset;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  -webkit-user-drag: element;
  cursor: pointer;
}

.caption-image,
.decorative-image::before {
  display: block;
  block-size: 18px;
  inline-size: 18px;
}

.decorative-image::before {
  content: "";
  -webkit-mask: var(--ch-tab-decorative-image) 50% 50%/100% 100% no-repeat;
  background-color: currentColor;
}

.close-button::after {
  content: "";
  display: flex;
  block-size: 1em;
  inline-size: 1em;
  -webkit-mask: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L15.5 15.5" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.5 2L2 15.5" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>') 50% 50%/0.75em 0.75em no-repeat;
  background-color: currentColor;
  opacity: 0;
}

.block__button {
  display: flex;
  align-items: center;
}
.block__button:hover > .close-button::after, .block__button:focus-within > .close-button::after, .block__button[aria-selected=true] > .close-button::after {
  opacity: 1;
}

.dragged-element {
  opacity: 0;
}
.dragged-element--outside {
  display: none;
}

.drag-preview {
  --ch-tab-snap-drag-preview: clamp(
    var(--ch-tab-tab-list-start),
    var(--ch-tab-mouse-position),
    var(--ch-tab-tab-list-end)
  );
  position: fixed;
  left: 0;
  top: 0;
  z-index: 108;
}
.drag-preview:popover-open {
  padding: 0;
  margin: 0;
  border: unset;
  color: unset;
  pointer-events: none;
}
.drag-preview-element {
  cursor: grabbing;
}
.drag-preview--outside-tab-list {
  transform: translate(calc(var(--ch-tab-mouse-position-x) - var(--ch-tab-mouse-offset-x)), calc(var(--ch-tab-mouse-position-y) - var(--ch-tab-mouse-offset-y)));
}
.drag-preview--inside-tab-list__block {
  --ch-tab-mouse-position: calc(
    var(--ch-tab-mouse-position-x) - var(--ch-tab-mouse-offset-x)
  );
  transform: translate(var(--ch-tab-snap-drag-preview), var(--ch-tab-button-position-y));
}
.drag-preview--inside-tab-list__inline {
  --ch-tab-mouse-position: calc(
    var(--ch-tab-mouse-position-y) - var(--ch-tab-mouse-offset-y)
  );
  transform: translate(var(--ch-tab-button-position-x), var(--ch-tab-snap-drag-preview));
}

.shifted-element {
  transition: transform var(--ch-tab-transition-duration);
}

:host(.ch-tab-direction--block) .shifted-element--start {
  transform: translate(calc(var(--ch-tab-button-size) * -1), 0);
}
:host(.ch-tab-direction--block) .shifted-element--end {
  transform: translate(var(--ch-tab-button-size), 0);
}

:host(.ch-tab-direction--inline) .shifted-element--start {
  transform: translateY(calc(var(--ch-tab-button-size) * -1));
}
:host(.ch-tab-direction--inline) .shifted-element--end {
  transform: translateY(var(--ch-tab-button-size));
}

.inline__tab-list {
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
}
:host([type=inlineEnd]) > .inline__tab-list {
  order: 1;
}

.block__tab-list {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
}

.page-container {
  display: grid;
  grid-template: "selected" 1fr/1fr;
  block-size: 100%;
  inline-size: 100%;
}

.page--selected {
  grid-area: selected;
}

@supports (content-visibility: hidden) {
  .page-container--collapsed,
.page--hidden {
    content-visibility: hidden;
  }

  .page-container--collapsed {
    inline-size: 0;
  }
}
@supports not (content-visibility: hidden) {
  .page-container--collapsed,
.page--hidden {
    display: none;
  }
}